import { useState, useEffect } from 'react'
import loadScript from './load-script'
import removeScript from './remove-script'
import axios from "axios"

const useGoogleLogin = ({
  onSuccess = () => {},
  onAutoLoadFinished = () => {},
  onFailure = () => {},
  onRequest = () => {},
  onScriptLoadFailure,
  clientId,
  cookiePolicy,
  loginHint,
  hostedDomain,
  autoLoad,
  isSignedIn,
  fetchBasicProfile,
  redirectUri,
  discoveryDocs,
  uxMode,
  scope,
  accessType,
  responseType,
  jsSrc = 'https://accounts.google.com/gsi/client',
  prompt
}) => {
  const [loaded, setLoaded] = useState(false);
  

  function handleSigninSuccess(res) {
    /*
      offer renamed response keys to names that match use
    */

    res.accessToken = res.config.params.access_token;

    res.profileObj = {
      imageUrl: res.data.picture,
      email: res.data.email,
      name: res.data.name,
      givenName: res.data.given_name,
      familyName: res.data.family_name
    }


    onSuccess(res)
  }

  function signIn(e) {
    if (e) {
      e.preventDefault() // to prevent submit if used within form
    }

    
    if (loaded) {
      window.tokenClient.requestAccessToken({ prompt: '' });

      window.tokenClient.callback = (resp) => {
       
        if (resp.error !== undefined) {
          throw(resp);
        }

      axios.get("https://www.googleapis.com/oauth2/v3/userinfo", {params:{access_token:resp.access_token}})
      .then(
        res => handleSigninSuccess(res),
        err => onFailure(err)
      );


      };

      
    }
    
  }

  useEffect(() => {
    let unmounted = false
    const onLoadFailure = onScriptLoadFailure || onFailure
    loadScript(
      document,
      'script',
      'google-login',
      jsSrc,
      () => {
        const params = {
          client_id: clientId,
          cookie_policy: cookiePolicy,
          login_hint: loginHint,
          hosted_domain: hostedDomain,
          fetch_basic_profile: fetchBasicProfile,
          discoveryDocs,
          ux_mode: uxMode,
          redirect_uri: redirectUri,
          scope,
          access_type: accessType
        }

        if (responseType === 'code') {
          params.access_type = 'offline'
        }
        
        
        window.tokenClient = window.google.accounts.oauth2.initTokenClient(params);
        setLoaded(true);

      //  
        
      },
      err => {
        onLoadFailure(err)
      }
    )

    return () => {
      unmounted = true
      removeScript(document, 'google-login')
    }
  }, [])

  useEffect(() => {
    
    if (autoLoad) {
      
      signIn()
    }
  }, [loaded])

  return { signIn, loaded }
}

export default useGoogleLogin
